import type { Message } from '@/lib/chat/types';

export type ChatSegment =
  | { kind: 'user'; message: Message }
  | { kind: 'assistant'; message: Message }
  | { kind: 'tools'; messages: Message[]; id: string };

/** Render messages in conversation order: assistant text, then its tool results. */
export function buildChatSegments(messages: Message[]): ChatSegment[] {
  const segments: ChatSegment[] = [];
  let pendingTools: Message[] = [];

  const flushTools = () => {
    if (pendingTools.length === 0) {
      return;
    }
    segments.push({
      kind: 'tools',
      messages: pendingTools,
      id: pendingTools[0]!.id,
    });
    pendingTools = [];
  };

  for (const message of messages) {
    if (message.role === 'tool') {
      pendingTools.push(message);
      continue;
    }

    if (message.role === 'user') {
      flushTools();
      segments.push({ kind: 'user', message });
      continue;
    }

    if (message.role === 'assistant') {
      flushTools();
      segments.push({ kind: 'assistant', message });
    }
  }

  flushTools();
  return segments;
}
